import { Component, inject, signal } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs';
import { FaConfig, FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fad, fab } from '@awesome.me/kit-971f2799ba/icons';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FontAwesomeModule],
  templateUrl: './app.html'
})
export class App {
  private router = inject(Router);

  // Covers the blank page during the very first route navigation - e.g. while the
  // initial AuthGuard/userLoadedGuard chain resolves after Auth0 redirects back into
  // the app. Only tracks the first navigation so normal in-app route changes (already
  // handled by per-page skeleton loaders) don't get a second, redundant overlay.
  public isBootstrapping = signal(true);

  constructor(library: FaIconLibrary, faConfig: FaConfig) {
    faConfig.defaultPrefix = 'fad';
    library.addIconPacks(fad, fab);

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError),
        take(1),
        takeUntilDestroyed()
      )
      .subscribe(() => this.isBootstrapping.set(false));
  }
}